import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import SmartText from '@reuters-graphics/react-smart-text';
import classnames from 'classnames';
import { component } from './styles.module.scss';
import { faLightbulb } from '@fortawesome/free-solid-svg-icons';

const NoteBox = ({ title, source, context = {}, red = false, collapsible = false }) => {
  return (
    <section className={classnames(component)}>
      <div className='section-spacer-internal' />
      <div className={collapsible ? 'noteBox collapsible' : 'noteBox'}>
        <h4
          className={red ? 'red' : ''}
        ><FontAwesomeIcon className='icon' icon={faLightbulb} /> {title}
        </h4>
        <SmartText
          source={source}
          context={context}
          multiline
        />
      </div>
      <div className='section-spacer-internal' />
    </section>
  );
};

export default NoteBox;
